
import React from 'react'
import Alert from 'ui/Alert'
import Link from 'ui/Link'
import css from './LoginError.module.css'

const WrongEmailAlert = () => (
  <Alert type='warning' title='Email does not exist'>
    This email does not seem to exist. <Link rel='external' href='/signup'>Signup</Link> or <Link rel='external' href='/forgot'>reset your password</Link>
  </Alert>
)

const WrongPasswordAlert = () => (
  <Alert type='warning' title='Password incorrect'>
    That’s not the right password. <Link rel='external' href='/forgot'>Forgot password?</Link>
  </Alert>
)

const GenericAlert = () => (
  <Alert type='danger' title='There seems to be a problem'>
    It looks like something went wrong and we can’t log you in right now. Email us at <Link href='mailto:friends@segment.com' target='_blank'>friends@segment.com</Link> so we can help you resolve this right away!
  </Alert>
)

const LoginError = props => {
  let alert = <GenericAlert />
  if (props.wrongPassword) {
    alert = <WrongPasswordAlert />
  } else if (props.wrongEmail) {
    alert = <WrongEmailAlert />
  }
  return <div className={css.main}>{alert}</div>
}

export default LoginError



// WEBPACK FOOTER //
// ./components/LoginError.js